import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import el from './locales/el.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      el: { translation: el },
    },
    lng: 'el',
    fallbackLng: 'el',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
